import React, { useState, useEffect, useRef } from 'react';
import {
  TextField,
  InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const InventorySearchBar = ({
  searchQuery,
  onSearchChange,
}) => {
  const [localSearchValue, setLocalSearchValue] = useState(searchQuery);
  const debounceTimerRef = useRef(null);

  // Update local value when external searchQuery changes (e.g., filter reset)
  useEffect(() => {
    setLocalSearchValue(searchQuery);
  }, [searchQuery]);

  // Debounce the search - only call onSearchChange after user stops typing
  const handleSearchInput = (value) => {
    setLocalSearchValue(value);

    // Clear existing timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    // Set new timer to trigger search after 300ms of no typing
    debounceTimerRef.current = setTimeout(() => {
      onSearchChange(value);
    }, 300);
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  return (
    <TextField
      size="small"
      placeholder="Search by title, item #, price..."
      value={localSearchValue}
      onChange={(e) => handleSearchInput(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
          </InputAdornment>
        ),
      }}
      sx={{
        minWidth: 250,
        flex: 1,
        maxWidth: 400,
      }}
    />
  );
};

export default React.memo(InventorySearchBar);
